<!--  -->
<template>
  <div class='foot--wrap'>
    <div class="foot__msg--wrap">
      <div class="foot__msg__left">
        <img src="../../images/logo-white.png"
             alt=""
             class="foot__msg_logo">
        <div class="foot__link--wrap">
          <span class="foot__link__title">友情链接</span>
          <a :href="item.link"
             class="foot__link__content"
             v-for="(item,index) in linkData"
             :key='index'
             target="_blank">{{ item.title }}</a>

        </div>
        <div class="foot__link--wrap">
          <span class="foot__link__title">联系我们</span>
          <span class="foot__contact__content">{{ email }} </span>
          <span class="foot__contact__content">{{phone}}（工作日9:00-18:00）</span>

        </div>
      </div>
      <div class="foot__msg__right">
        <span class="foot__msg__right__title">关注我们</span>
        <img src="../../images/gzh_qr.png"
             class="foot__qr"
             alt="">
        <span class="foot__msg__right__s__title">公众号</span>
      </div>
    </div>
    <div class="
              line">
    </div>
    <div class="foot__net--wrap">
      <span class="foot__net">©2023-2026 浪微澜科技（广州）有限公司 版权所有</span>
      <!-- <span class="foot__net">粤ICP备2023103503号-1</span> -->
      <a href="https://beian.miit.gov.cn"
         class="foot__net foot__a"
         target="_blank">粤ICP备2023103503号-1</a>
    </div>
  </div>
</template>

<script>

export default {
  name: 'FootView',

  data () {
    return {
      phone: '020-26232815',
      email: 'gzlangweilan@163.com',
      linkData: [
        { title: '数安时代科技股份有限公司', link: 'https://www.gdca.com.cn' },
        { title: '广州市代理记账协会', link: 'http://www.gzdljzxh.org.cn/portal/index' },
        { title: '广东政府服务网-信任广州平台', link: 'http://szg.gz.gov.cn/kxrz/trustgz/#/login' }
      ]
    }
  },
  computed: {},
  watch: {},
  // 方法集合
  methods: {

  },
  created () {

  },
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.foot--wrap {
  height: 292px;
  padding: 64px 360px 44px 360px;
  background: black;
  .foot__msg--wrap {
    display: flex;
    justify-content: space-between;
    .foot__msg__left {
      .foot__msg_logo {
        width: 171.05px;
        height: 52px;
        opacity: 1;
        margin-bottom: 40px;
      }
      .foot__link--wrap {
        margin-top: 24px;
        .foot__link__title {
          color: rgba(255, 255, 255, 0.8);
          font-size: 14px;
        }
        .foot__link__content {
          margin-left: 24px;
          color: rgba(255, 255, 255, 0.5);
          font-size: 14px;
          text-decoration: none;
          &:hover {
            color: $color-primary;
          }
        }
        .foot__contact__content {
          margin-left: 24px;
          color: rgba(255, 255, 255, 0.5);
          font-size: 14px;
        }
      }
    }
    .foot__msg__right {
      display: flex;
      flex-direction: column;
      .foot__msg__right__title {
        font-size: 18px;
        font-weight: 500;
        letter-spacing: 0px;

        color: rgba(255, 255, 255, 1);
      }
      .foot__qr {
        width: 116px;
        margin-top: 24px;
        height: 116px;
      }
      .foot__msg__right__s__title {
        width: 116px;
        font-size: 16px;
        font-weight: 500;
        letter-spacing: 0px;
        margin-top: 12px;

        color: rgba(255, 255, 255, 1);
        // transform: translateX(-50%);
        // position: relative;
        // left: 50%;
        text-align: center;
      }
    }
  }
  .line {
    height: 1px;
    width: 100%;
    background: rgba(255, 255, 255, 0.2);
    position: absolute;
    left: 0px;
    margin-top: 24px;
  }
}
.foot__net--wrap {
  display: flex;
  justify-content: space-between;
  margin-top: 70px;
  .foot__net {
    /** 文本1 */
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;

    color: rgba(255, 255, 255, 0.5);
  }
  .foot__a {
    text-decoration: none;
    &:hover {
      color: $color-primary;
    }
  }
}
</style>
